import { CallBubble } from "@notifications/CallBubble";
import { AnsweredCallNavigation } from "@phone/AnsweredCallNavigation";
import { BrianBubbleProvider } from "@shell/brianBubble";
import { BrianCorner } from "@shell/BrianCorner";
import { Outlet } from "@tanstack/react-router";

/** The front desk, under a staff session (BRI-131). Paired room and board screens render `DisplayHome` instead. */
export const FrontDeskLayout = () => (
  <BrianBubbleProvider>
    <AnsweredCallNavigation />
    <div className="flex h-screen w-screen flex-col overflow-hidden bg-wall font-body text-ink-body">
      <Outlet />
      <BrianCorner>
        <CallBubble />
      </BrianCorner>
    </div>
  </BrianBubbleProvider>
);
